import config from "../config.json";

const Config = {    
  API_ROOT: config.api_root,
  PAGE_SIZE: 200
};
  
export default Config;